import React, { useCallback } from "react";
import ReadOnlyListPanel from "../../components/ReadOnlyListPanel";
import { getPublicEvents } from "../../api/classicSiteHoodieApi";

export default function PublicEventsPage() {
  const load = useCallback(() => getPublicEvents(), []);

  return (
    <ReadOnlyListPanel
      title="Upcoming public events (hoodie API)"
      load={load}
      render={(rows) => (
        <ul className="cs-list">
          {(rows || []).map((event) => (
            <li key={event.id} className="cs-list__item">
              <strong>{event.name}</strong>
              {event.entry?.business_name ? (
                <span> — {event.entry.business_name}</span>
              ) : null}
              {event.start_datetime ? (
                <div className="cs-list__meta">{event.start_datetime}</div>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    />
  );
}
